module.exports = __webpack_public_path__ + "img/11-ค่าประกันและต่าบัตรสมาชิก.57e8724c.jpg";